/**
 * Created by evgeny on 11.06.2024
 */

const HomefixOrangery = Object.create(MergeOrangery);

HomefixOrangery.init = function () {
    const tabs = [];

    this.addEditorTabs(tabs);

    tabs.forEach((tab) => {
        tab.rows.unshift([{
            eraser: true,
            id: tab.id,
            itemIcon: new cc.Sprite(bundles.orangery.frames.eraser_icon),
            minimizedIcon: new cc.Sprite(bundles.orangery.frames.eraser_icon)
        }]);
    });

    this.tabs = tabs;
};

HomefixOrangery.addEditorTabs = function (tabs) {
    if (Map2d.currentMap.families) {
        tabs.push({
            icon: bundles.orangery.frames.tab_icon_ground,
            rows: Object.keys(Map2d.currentMap.families)
                .filter((code) => ["multiCellBody"].indexOf(code) === -1)
                .map((family) => this.listUnitsByCode(family, false))
        });
    }

    if (cleverapps.config.editorMode) {
        tabs.push({
            icon: bundles.orangery.frames.tab_icon_fogs,
            rows: this.listFogs(),
            id: MergeOrangery.REGION_ID
        });
        tabs.push({
            icon: bundles.orangery.frames.tab_icon_ground,
            layer: Map2dEditor.LAYER_GROUND,
            rows: this.listTiles()
        });
        tabs.push({
            icon: bundles.orangery.frames.tab_icon_regions,
            rows: this.listRegions(),
            id: MergeOrangery.REGION_ID
        });
        tabs.push({
            icon: bundles.orangery.frames.tab_icon_decorators,
            rows: this.listDecorators(),
            layer: Map2dEditor.LAYER_DECORATORS,
            id: MergeOrangery.DECORATOR_ID
        });
        tabs.push({
            icon: bundles.orangery.frames.tab_icon_terrain,
            rows: this.listTerrains(),
            layer: Map2dEditor.LAYER_DECORATORS,
            id: MergeOrangery.DECORATOR_ID
        });
    }
};
